import React from 'react';

import { BenefitsTabName, FIELDS_TO_WATCH } from '@epi-constants/beneficiary';
import { FormFields } from '@epi-forms/helpers';
import { Box } from 'edenred-ui';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
  BenefitGroupSelector,
  PersonalData
} from '../../BeneficiaryDetail/components';
import { ErrorCounterBadge } from '../BeneficiariesModal.styles';

export const useBeneficiaryTabs = (
  isAdd: boolean,
  isShowModal: boolean,
  isGroupManagementAllowed: boolean
) => {
  const { t } = useTranslation();
  const {
    watch,
    formState: { errors, isDirty }
  } = useFormContext();

  const watchedValues = watch();

  const groupId = watchedValues[FormFields.GroupId];
  const benefitsErrors = errors[FormFields.GroupId];

  const shouldCheckErrors = isShowModal && (isAdd || isDirty);

  const personalDataErrorCount = shouldCheckErrors
    ? FIELDS_TO_WATCH.filter(field => errors[field] || !watchedValues[field])
        .length
    : 0;

  const benefitsErrorCount =
    shouldCheckErrors && (!!benefitsErrors || !groupId) ? 1 : 0;

  const tabs = [
    {
      name: BenefitsTabName.personalData,
      label: (
        <Box display="flex" alignItems="center">
          {t('containers.beneficiaries.detail.personal_data')}
          {personalDataErrorCount > 0 && (
            <ErrorCounterBadge>{personalDataErrorCount}</ErrorCounterBadge>
          )}
        </Box>
      ),
      id: 'tab-personal-data',
      body: <PersonalData isAdd={isAdd} />
    },
    {
      name: BenefitsTabName.benefits,
      label: (
        <Box display="flex" alignItems="center">
          {t('containers.beneficiaries.detail.benefits')}
          {benefitsErrorCount > 0 && (
            <ErrorCounterBadge>{benefitsErrorCount}</ErrorCounterBadge>
          )}
        </Box>
      ),
      id: 'tab-benefits',
      body: (
        <BenefitGroupSelector
          isGroupManagementAllowed={isGroupManagementAllowed}
        />
      )
    }
  ];

  return {
    tabs
  };
};
